export const Endpoints = {
  auth: {
    login: 'api/app/Auth/login',
  },
  category: {
    getTree: "Ecommerce-api/ProductCategory/GetTree",
  },
  bard: {
    getList: "Ecommerce-api/master-data/SearchBrands"
  },
  product: {
    topSale : "Ecommerce-api/Product/SearchTopSale",
    searchProduct: "Ecommerce-api/Product/SearchProduct",
    detailProduct: "Ecommerce-api/Product/GetById",
    related: "Ecommerce-api/Product/SearchRelatedProducts"
  },
  banner: {
    search: "Ecommerce-api/Banner/SearchBanner"
  }
} as const;
